/* HAZAR REKLAM — tema betiği */
(function () {
  'use strict';

  /* ---- mobil çekmece ---- */
  var burger = document.querySelector('[data-drawer-toggle]');
  if (burger) {
    burger.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Menüyü kapat' : 'Menüyü aç');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
      document.body.classList.remove('nav-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---- çekmece alt menü ---- */
  Array.prototype.forEach.call(document.querySelectorAll('.drawer__toggle'), function (t) {
    t.addEventListener('click', function () {
      var open = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  /* ---- galeri filtresi ---- */
  var filterBar = document.querySelector('[data-filters]');
  var gallery = document.querySelector('[data-gallery]');
  if (filterBar && gallery) {
    filterBar.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-cat]');
      if (!btn) return;
      var cat = btn.getAttribute('data-cat');
      Array.prototype.forEach.call(filterBar.querySelectorAll('button'), function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      Array.prototype.forEach.call(gallery.children, function (fig) {
        var show = cat === 'all' || fig.getAttribute('data-cat') === cat;
        if (show) { fig.removeAttribute('hidden'); } else { fig.setAttribute('hidden', ''); }
      });
    });
  }

  /* ---- görünüme girince yumuşak açılış ---- */
  var items = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    Array.prototype.forEach.call(items, function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target;
          var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
          el.style.transitionDelay = Math.min(sibs, 5) * 60 + 'ms';
          el.classList.add('in');
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
  }

  /* ---- telefon alanı basit maskeleme ---- */
  var tel = document.querySelector('input[type="tel"]');
  if (tel) {
    tel.addEventListener('input', function () {
      var v = tel.value.replace(/\D/g, '').slice(0, 11);
      var out = v;
      if (v.length > 4) out = v.slice(0, 4) + ' ' + v.slice(4);
      if (v.length > 7) out = v.slice(0, 4) + ' ' + v.slice(4, 7) + ' ' + v.slice(7);
      if (v.length > 9) out = v.slice(0, 4) + ' ' + v.slice(4, 7) + ' ' + v.slice(7, 9) + ' ' + v.slice(9);
      tel.value = out;
    });
  }

  /* ---- form gönderildiyse mesaja kaydır ---- */
  var ok = document.querySelector('.form__ok');
  if (ok) { setTimeout(function () { ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 250); }
})();
